export enum OSEnum {
  none,
  android,
  ios,
  windowsPhone
}